function bootstrapQueue(writeKey) {
    (function(){
    const i = "analytics";
    const analytics = (window )[i] = (window )[i] || [];
    if (analytics.initialize || analytics.invoked) return;
    analytics.invoked = true;
    analytics.methods = [
      "trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset",
      "group","track","ready","alias","debug","page","screen","once","off","on",
      "addSourceMiddleware","addIntegrationMiddleware","setAnonymousId",
      "addDestinationMiddleware","register"
    ];
    analytics.factory = function(method) {
      return function() {
        if ((window )[i].initialized) return (window )[i][method].apply((window )[i], arguments);
        const args = Array.prototype.slice.call(arguments);
        if (["track","screen","alias","group","page","identify"].indexOf(method) > -1) {
          const c = document.querySelector("link[rel='canonical']")
          const { pathname, href, search } = window.location;
          args.push({
            __t:"bpc",
            c: c && c.getAttribute("href") || undefined,
            p: pathname,
            u: href,
            s: search,
            t: document.title,
            r: document.referrer
          });
        }
        args.unshift(method);
        analytics.push(args);
        return analytics;
      }
    };
    for (let n = 0; n < analytics.methods.length; n++) {
      const key = analytics.methods[n];
      analytics[key] = analytics.factory(key);
    }
    analytics._writeKey = writeKey;
    analytics.SNIPPET_VERSION = "5.2.0";
  })();
}

export function initSegment() {
  const key = process.env.REACT_APP_SEGMENT_KEY;
  if (!key) {
    if (process.env.NODE_ENV !== "production") {
      console.warn("Segment: REACT_APP_SEGMENT_KEY is missing");
    }
    return;
  }

  bootstrapQueue(key);

  const s = document.createElement("script");
  s.type = "text/javascript";
  s.async = true;
  s.setAttribute("data-global-segment-analytics-key", "analytics");
  s.src = `https://cdn.segment.com/analytics.js/v1/${key}/analytics.min.js`;
  const first = document.getElementsByTagName("script")[0];
  first.parentNode?.insertBefore(s, first);

  s.onload = () => {
    // познач сторінку
    window.analytics?.page();
  };
}

export const track = (name, props) =>
  window.analytics?.track?.(name, props);

export const identify = (id, traits) =>
  window.analytics?.identify?.(id, traits);
